// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608181231/js/" + chunkId + "." + {"44":"9e412405","225":"8091624c","481":"630665d1","486":"9e06c630","770":"b47da806"}[chunkId] + ".0.541516485417079.chunk.js";
};